import React from 'react'
import styled from 'styled-components'

import ModalImage from 'react-modal-image'

import ParseContent from 'components/shared/ParseContent'

const Price = styled.h6`
  text-align: right;
  font-size: 18px;
  @media (max-width: 767px) {
    font-size: 15px;
  }
`

const ItemTitle = styled.h3`
  font-weight: bold;
  @media (max-width: 767px) {
    font-size: 18px;
  }
`

const Content = styled(ParseContent)`
  display: flex;
  align-items: center;
  flex-direction: column;
  border: 2px solid black;
  padding: 1rem;
  p {
    margin-bottom: 0;
  }
  & a {
    color: ${({ theme }) => theme.color.face.main};
    &:hover {
      text-decoration: underline;
    }
  }
`

const StyledModalImage = styled(ModalImage)`
  max-width: 300px;
`

function Shopcolumns({ item, textdown }) {
  return (
    <section className="my-5">
      <div className="container">
        <div className="row">
          {item.map((item, index) => (
            <div className="col-sm-4 col-6 mb-5" key={index}>
              <StyledModalImage
                small={item.image.localFile.publicURL}
                large={item.image.localFile.publicURL}
                className="mb-3"
              ></StyledModalImage>
              <div className="d-flex justify-content-between align-items-center">
                <ItemTitle>{item.title}</ItemTitle>
                <Price>{item.price}</Price>
              </div>

              <p>{item.description}</p>
            </div>
          ))}
        </div>
        <div className="d-flex justify-content-center align-items-center">
          <Content content={textdown} />
        </div>
      </div>
    </section>
  )
}

export default Shopcolumns
